/**
 * Formats YYYY-MM-DD to European DD.MM.YYYY (no timezone shift).
 */
export function formatBlogDate(isoDateString) {
  if (!isoDateString || typeof isoDateString !== "string") return "";
  const parts = isoDateString.trim().split("-");
  if (parts.length !== 3) return isoDateString;
  const [year, month, day] = parts;
  if (!year || !month || !day) return isoDateString;
  const d = String(day).padStart(2, "0");
  const m = String(month).padStart(2, "0");
  return `${d}.${m}.${year}`;
}
